import {DEFAULT_RELAY_CACHE_TTL} from '@github-ui/relay-query-cache/helpers'
import {clientSideRelayFetchQueryRetainedWithCache} from '@github-ui/relay-query-cache/query-helpers'
import {useEffect, useState} from 'react'
import {useRelayEnvironment} from 'react-relay'

import type {
  IssueRowSecondaryQuery,
  IssueRowSecondaryQuery$data,
} from '../components/__generated__/IssueRowSecondaryQuery.graphql'
import {IssuesIndexSecondaryGraphqlQuery} from '../components/IssueRow'

type UseIssueIndexSecondaryQueryProps = {
  nodes: string[]
  includeReactions: boolean
}

export function useIssueIndexSecondaryQuery({
  nodes,
  includeReactions,
}: UseIssueIndexSecondaryQueryProps): IssueRowSecondaryQuery$data | null {
  const environment = useRelayEnvironment()
  const [secondaryQueryData, setSecondaryQueryData] = useState<IssueRowSecondaryQuery$data | null>(null)

  useEffect(() => {
    clientSideRelayFetchQueryRetainedWithCache<IssueRowSecondaryQuery>(
      {
        environment,
        query: IssuesIndexSecondaryGraphqlQuery,
        variables: {
          nodes,
          includeReactions,
        },
      },
      DEFAULT_RELAY_CACHE_TTL,
    ).subscribe({
      next: (data: IssueRowSecondaryQuery$data) => {
        setSecondaryQueryData(data)
      },
    })
  }, [environment, nodes, includeReactions])

  return secondaryQueryData
}
